import { useSearchParams } from 'react-router'

import { SkeletonRows } from '@/components/ui/skeleton'
import { useCurrentUser } from '../../../../models/user'
import { ClaimForm } from './ClaimForm'

export function NewClaim() {
  const { user } = useCurrentUser({ enabled: true })

  // A CAI user opening the wizard from a customer page passes ?org_id=&user_id= to
  // create the claim on behalf of that customer's business owner.
  const [searchParams] = useSearchParams()
  const onBehalfOrgId = searchParams.get('org_id') ?? undefined
  const onBehalfUserId = searchParams.get('user_id') ?? undefined

  // Wait for the user so the form's defaultValues are right on first mount.
  if (!user) return <SkeletonRows className="mt-10" rows={6} />

  // The reporter is whoever is signed in and filing, Cai staff filing for a customer included.
  return (
    <ClaimForm
      orgId={onBehalfOrgId}
      userId={onBehalfUserId}
      reporterName={`${user.firstName} ${user.lastName}`.trim()}
      reporterPhone={user.mobile}
    />
  )
}
